// Backend-authored dashboard pages (market_map / salary_benchmark). We clamp
// the section count and rename the chart's snake_case fields; nothing else.

import type { BlockOutput } from '../../types';
import { mapSuggestedActions } from './shared';
import type { StructuredDashboard } from './types';

const MAX_DASH_SECTIONS = 14;

export const buildDashboardBlock = (
  t: StructuredDashboard,
  toolCallId?: string
): BlockOutput => {
  const sections = (t.sections ?? []).slice(0, MAX_DASH_SECTIONS).map((raw) => {
    const s = raw as Record<string, never>;
    const chart = s.chart as Record<string, never> | undefined;
    const grid = s.grid as Record<string, never> | undefined;
    return {
      kind: s.kind,
      title: s.title,
      confidence: s.confidence,
      source: s.source,
      kpis: s.kpis,
      chart: chart
        ? {
            chartType: chart.chart_type,
            unit: chart.unit,
            numberFormat: chart.number_format,
            categories: chart.categories,
            series: chart.series,
            ranges: ((chart.ranges ?? []) as Record<string, never>[]).map(
              (r) => ({
                label: r.label,
                p25: r.p25,
                p50: r.p50,
                p75: r.p75,
                p90: r.p90,
                currentMin: r.current_min,
                currentMax: r.current_max,
                recMin: r.rec_min,
                recMax: r.rec_max,
              })
            ),
          }
        : undefined,
      cards: s.cards,
      bands: s.bands,
      tagSets: s.tag_sets,
      grid: grid
        ? {
            columns: grid.columns,
            rows: grid.rows,
            accentCol: grid.accent_col,
          }
        : undefined,
      items: s.items,
      text: s.text,
      split: s.split,
      links: s.links,
    };
  });
  return {
    type: 'dashboard',
    data: {
      dashboard: t.dashboard ?? 'dashboard',
      title: t.title,
      subtitle: t.subtitle,
      sections: sections as never,
      suggestedActions: mapSuggestedActions(t.suggested_actions),
      toolCallId,
    },
  };
};
